import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        mergingPatientGridIsOpen: false,
        patientGridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új Páciens',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "email",
                label: "E-mail",
                formType: "email",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3,
                readonly:false
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
        ],
        nonMedDocumentTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showEvidenceDocument'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteNonMedRow'
            }
        ],
        nonMedDocumentTableHeaderFields: [
            {
                label: "Azonosító",
                name: "id",
                visibility: false
            },
            {
                label: "Azonosító",
                name: "patientId",
                visibility: false
            },
            {
                label: "Fájl tartalom",
                name: "fileData",
                visibility: false
            },
            {
                label: "Fájlnév",
                name: "fileName",
                sort: true,
                visibility: true
            },
            {
                label: "Kategória",
                name: "documentCategory",
                visibility: true
            },
            {
                label: "Feltöltés időpontja",
                name: "createdOn",
                slot_name: "created_on_format",
                sort: true,
                visibility: true
            },
            {
                label: "Feltöltő",
                name: "createdBy",
                sort: true,
                visibility: true
            },
            // {
            //     label: "Módosítás dátuma",
            //     name: "modifiedOn",
            //     slot_name: "modified_on_format",
            //     sort: true,
            //     visibility: false,
            // },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        
        patientSearchDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            },
            per_page: 10,
        },
        patientSearchActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
        ],
        patientSearchRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
        patientSearchHeaderFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
            },
            {
                name: "email",
                label: "E-mail",
                formType: "email",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3,
                slot_name: "startDate_format"
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3,
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true,

            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formType: "text",
                formSize: 3,
                formVisible: true,

            },
        ],
        patientTableFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3,
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
            },
            {
                name: "email",
                label: "E-mail",
                formType: "email",
                formSize: 3,
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3,
                slot_name: "startDate_format"
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3,
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formType: "text",
                formSize: 3,
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formType: "text",
                formSize: 3,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        
        ocuHeaPatientTableFields: [
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                formType: "text",
                formSize: 3,
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
            },
            {
                name: "email",
                label: "E-mail",
                filter: {
                    type: "simple",
                },
                formType: "email",
                formSize: 3,
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3,
                slot_name: "startDate_format"
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                filter: {
                    type: "simple",
                },
                formType: "text",
                formSize: 3,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formType: "text",
                formSize: 3,
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formType: "text",
                formSize: 3,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        samePatientSearchDataTableOptions: {
            server_mode: false,
            show_reset_button: false,
            global_search: {
                visibility: false,
            },
            per_page: 10,
        },
        samePatientTableFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3,
                filter: {
                    type: "simple",
                },
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
                filter: {
                    type: "simple",
                },
            },
            {
                name: "email",
                label: "E-mail",
                formType: "email",
                formSize: 3,
                filter: {
                    type: "simple",
                },
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3,
                slot_name: "startDate_format",
                filter: {
                    type: "simple",
                },
            },
            {
                name: "motherName",
                label: "Anyja neve",
                filter: {
                    type: "simple",
                },
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3,
                filter: {
                    type: "simple",
                },
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        patientMembershipFormHeaderFields: [
            {
                name: "patientId",
                label: "Páciens azonosító",
                formVisible: false
            },
            {
                name: "membershipType",
                label: "Tagság típusa",
                formVisible: true,
                formSize: 4,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getMembershipTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "membershipExpirationDate",
                label: "Tagság lejárata",
                formVisible: true,
                formSize: 4,
                formRequired: true,
                formType: "date"
            },
            {
                name: "membershipFee",
                label: "Tagság díja",
                formVisible: true,
                formSize: 4,
                formRequired: true,
                formType: "number"
            }
        ]
    }
}
